/**
 * Page loading placeholder component
 * Used for loading state during route lazy loading
 * Currently hidden for testing no-loading effect
 */
const PageLoading = () => <div style={{ display: 'none' }} />;

export default PageLoading;
